"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonHelperService = void 0;
var SeismicUrlConstants_1 = require("../constants/SeismicUrlConstants");
var JsonApi_service_1 = require("./jsonServiceApi/JsonApi.service");
var PreloadData_service_1 = require("./PreloadData.service");
var CommonService_decorator_1 = require("../../core/decorators/CommonService.decorator");
var ServiceAddress_service_1 = require("../../core/services/ServiceAddress.service");
var MonolithUser_service_1 = require("../../monolith/services/MonolithUser.service");
/**
 * The CommonHelper Service is made to replace a lot of the logic from the commonHelper service in full bundle.
 * While there isn't an exact 1 to 1 match this should contain a good amount of functionality
 */
var CommonHelperService = /** @class */ (function () {
    function CommonHelperService(userService, jsonApiService, serviceAddressService, preloadDataService) {
        this.userService = userService;
        this.jsonApiService = jsonApiService;
        this.serviceAddressService = serviceAddressService;
        this.preloadDataService = preloadDataService;
    }
    CommonHelperService_1 = CommonHelperService;
    /**
     * @deprecated
     * **Please stop using this!**
     * It should work, but it's using Library service. Shouldn't you use BSS instead?
     * Try BlobStorageApiService
     *
     * Gets a download url for a given file
     * @param fileId
     * @param fileName
     * @param fileFormat
     * @param contentType
     * @param isPersonal Whether or not this is in workspace
     */
    CommonHelperService.prototype.getFileUrlV2 = function (fileId, fileName, fileFormat, contentType, isPersonal) {
        var loginInfo = this.userService.getLoginInfo();
        var url = "/Download/DownloadFileV2.ashx?tenant=" + escape(loginInfo.tenant) + "&user=" + escape(loginInfo.username);
        url +=
            '&fileid=' +
                escape(fileId) +
                '&filename=' +
                encodeURIComponent(this.getFileNameToDownload(fileName, fileFormat)) +
                '&format=' +
                escape(fileFormat) +
                '&clienttype=' +
                escape(loginInfo.clientType) +
                '&contentType=' +
                (contentType || '') +
                '&personal=' +
                (isPersonal ? 1 : '');
        return url;
    };
    /**
     * @deprecated
     * **Please stop using this!**
     * The ArticleV2 is retiring and all consumers are migrating to ArticleV3.
     * For more details please check https://seismic.atlassian.net/browse/FEARCH-552?focusedCommentId=529540
     */
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    CommonHelperService.prototype.getArticlev2OnlineTemplate = function (structure, $app, contentName, language) {
        if (contentName === void 0) { contentName = ''; }
        if (language === void 0) { language = 'en-US'; }
        var cssUrl = window.seismicArticlev2WebViewerCSS;
        var jsUrl = window.seismicArticlev2WebViewerJS;
        var customHeaders = {
            SeismicClientName: this.userService.getLoginInfo().clientType
        };
        var authToken = this.userService.getAccessToken();
        var loginInfoTemplate = __assign({}, $app.loginInfo);
        delete loginInfoTemplate.clientInfo;
        var jsonCustomHeaders = '{}';
        try {
            jsonCustomHeaders = JSON.stringify(customHeaders);
        }
        catch (e) {
            console.error('customHeaders stringfy error', customHeaders);
        }
        return "<!DOCTYPE html>\n    <html>\n    <head>\n        <meta charset=\"utf-8\" />\n        <meta name=\"viewport\" content=\"width=device-width, initial-scale=1\">\n        <link rel=\"stylesheet\" href=\"" + cssUrl + "\">\n        <title></title>\n        <style>\n            template {\n                display: none;\n            }\n        </style>\n        <script>\n            window.__custom_headers__ = " + jsonCustomHeaders + ";\n            window.__content_name__ = \"" + contentName + "\";\n            window.__custom_language__= \"" + language + "\";\n            window.__cdn_url__ = \"" + window.__cdn_url__ + "\";\n            window.localWebCDNUrl = \"" + window.localWebCDNUrl + "\";\n            window.versionJSFolder = \"" + window.versionJSFolder + "\";\n            window.authSetting = {\n                authToken: \"" + authToken + "\",\n                loginInfo: " + JSON.stringify(loginInfoTemplate, null, 4) + ",\n                timeZoneOffset: " + window.$App.timeZoneOffset + ",\n            };\n            window.microServiceSetting = {\n                serviceDiscoveryServiceUrl: \"\",\n                address: \"" + window.$App.ApplicationInfo.serviceAddress.article + "\"\n            };\n            window.authToken = \"" + authToken + "\";\n            window.isDebug = " + (window.isDebug === 'True') + ";\n        </script>\n    </head>\n    <body>\n        " + structure + "\n    </body>\n    <script type=\"text/javascript\" src=\"" + jsUrl + "\"></script>\n    </html>\n    ";
    };
    CommonHelperService.prototype.openFolderOrDocMode = function () {
        if (window.EmbeddedPage) {
            return 'click';
        }
        else {
            return 'link';
        }
    };
    CommonHelperService.prototype.bytesToString = function (bytes) {
        var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (bytes <= 0)
            return '0 Byte';
        var i = Math.floor(Math.log(bytes) / Math.log(1024));
        return Math.round(bytes / Math.pow(1024, i)) + ' ' + sizes[i];
    };
    /**
     * @deprecated
     * **Please stop using this!**
     * It should work, but it's using Library service. Shouldn't you use BSS instead?
     * Try BlobStorageApiService
     */
    CommonHelperService.prototype.getImageUrl = function (imageId, tintColor) {
        var url = '';
        if (imageId) {
            if (imageId.indexOf(OLD_PREVIEW_NAME) > -1) {
                url = NEW_THUMBNAIL_URL;
            }
            else if (imageId.indexOf(OLD_URL_PREVIEW_NAME) > -1) {
                url = NEW_URL_THUMBNAIL_URL;
            }
            else {
                var loginInfo = this.userService.getLoginInfo();
                url = location.protocol + "//" + location.host + "/Resource/Image.ashx?tenant=" + loginInfo.tenant + "&user=" + this.escapeUserName(loginInfo.username) + "&client=" + loginInfo.clientType + "&imageid=" + imageId;
                if (tintColor) {
                    url += '&tintcolor=' + tintColor;
                }
            }
        }
        return url;
    };
    /**
     * @deprecated
     * **Please stop using this!**
     * It seems useless
     * Try BlobStorageApiService
     */
    CommonHelperService.prototype.getImageServerUrl = function () {
        return __awaiter(this, void 0, void 0, function () {
            var domain;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.serviceAddressService.getAllServiceAddresses()];
                    case 1:
                        domain = (_a.sent()).bss;
                        if (!domain.startsWith('https://') && !domain.startsWith('http://')) {
                            domain = 'https://' + domain;
                        }
                        if (!domain.endsWith('/')) {
                            domain = domain + '/';
                        }
                        if (domain) {
                            return [2 /*return*/, domain + 'api/image/v1'];
                        }
                        return [2 /*return*/, ''];
                }
            });
        });
    };
    /**
     * @deprecated
     * **Please stop using this!**
     * It seems not working, because it's a sync function with calling async getImageServerUrl without await
     * Try BlobStorageApiService
     */
    CommonHelperService.prototype.getImageResizeUrl = function (containerName, blobId, sizeStr) {
        if (sizeStr === void 0) { sizeStr = 'SmallMedium'; }
        var allSizeList = ['Origin', 'ExtralSmall', 'Small', 'SmallMedium', 'Medium', 'Large', 'ExtraLarge'];
        var targetSize = allSizeList.find(function (size) { return size.toLowerCase() === sizeStr.toLowerCase(); });
        if (!targetSize) {
            targetSize = 'SmallMedium';
        }
        var blobIdFormat = blobId;
        if (blobId.length === 37 && blobId.substr(0, 1).toLowerCase() === 't') {
            blobIdFormat = blobId.substr(1, 36);
        }
        var redirecturi = window.encodeURIComponent(CommonHelperService_1.IMAGE_NOT_FOUND_URL);
        // var relativeUrl = `/${this.$App.loginInfo.tenant}/${containerName}/${blobId}`
        return this.getImageServerUrl() + "/" + this.userService.getLoginInfo().tenant + "/" + containerName + "/" + blobIdFormat + "?requestSize=" + targetSize + "&redirecturi=" + redirecturi;
    };
    /**
     * @deprecated
     * **Please stop using this!**
     * It seems not working, try BlobStorageApiService
     */
    CommonHelperService.prototype.getFitImageURL = function (containerName, blobId, size, needDefaultImage) {
        if (blobId === void 0) { blobId = ''; }
        if (size === void 0) { size = 'SmallMedium'; }
        if (needDefaultImage === void 0) { needDefaultImage = false; }
        if (containerName && blobId) {
            return this.getImageResizeUrl(containerName, blobId, size);
        }
        if (needDefaultImage) {
            return CommonHelperService_1.IMAGE_NOT_FOUND_URL;
        }
        return '';
    };
    CommonHelperService.prototype.getFileNameToDownload = function (fileName, format) {
        var downloadFileName = this.getValidFileName(fileName);
        var fileExt = '.' + this.getFileExtFromFormat(format);
        downloadFileName = downloadFileName.replace(/\.xlsx-model$/, '.xlsx');
        if (format && format !== 'UNKNOWN' && !downloadFileName.toLowerCase().match('\\' + fileExt)) {
            downloadFileName = downloadFileName + fileExt;
        }
        return downloadFileName;
    };
    /**
     * @deprecated
     * **Please stop using this!**
     * It should work, but it's using Library service. Shouldn't you use BSS instead?
     * Try BlobStorageApiService
     */
    CommonHelperService.prototype.getThumbnailUrl = function (thumbnailUrl, imageId, tintColor) {
        if (thumbnailUrl) {
            var url = '';
            if (imageId) {
                if (imageId.indexOf(OLD_PREVIEW_NAME) > -1) {
                    url = NEW_THUMBNAIL_URL;
                }
                else if (imageId.indexOf(OLD_URL_PREVIEW_NAME) > -1) {
                    url = NEW_URL_THUMBNAIL_URL;
                }
                else {
                    url = thumbnailUrl;
                }
            }
            else {
                url = thumbnailUrl;
            }
            return url;
        }
        else {
            return this.getImageUrl(imageId, tintColor);
        }
    };
    /**
     * @deprecated
     * **Please stop using this!**
     * It should work, but it's using Library service. Shouldn't you use BSS instead?
     * Try BlobStorageApiService
     */
    CommonHelperService.prototype.getFileUrl = function (fileId, fileName, fileFormat, contentType, isPersonal) {
        return __awaiter(this, void 0, void 0, function () {
            var loginInfo, url, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        loginInfo = this.userService.getLoginInfo();
                        if (!loginInfo) return [3 /*break*/, 2];
                        _a = SeismicUrlConstants_1.SeismicUrlConstants.DOWNLOAD_ROOT_URL;
                        return [4 /*yield*/, this.jsonApiService.getParamsWithSignature('DownloadFileWithSignature.ashx', loginInfo.tenant, loginInfo.username, loginInfo.accessKey)];
                    case 1:
                        url = _a +
                            (_b.sent());
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        url +=
                            '&fileid=' +
                                escape(fileId) +
                                '&filename=' +
                                encodeURIComponent(this.getFileNameToDownload(fileName, fileFormat.Format || fileFormat)) +
                                '&format=' +
                                escape(fileFormat) +
                                '&clienttype=' +
                                escape(loginInfo.clientType) +
                                '&contentType=' +
                                (contentType || '') +
                                '&personal=' +
                                (isPersonal ? 1 : '');
                        return [2 /*return*/, url];
                    case 2: return [2 /*return*/, ''];
                }
            });
        });
    };
    CommonHelperService.prototype.getValidFileName = function (fileName) {
        var replaceChar = '_';
        var regEx = new RegExp('[,/:*?""<>|]', 'g');
        return fileName.replace(regEx, replaceChar);
    };
    CommonHelperService.prototype.getFileExtFromFormat = function (format) {
        var _format = format;
        if (format && format.Format) {
            _format = format.Format;
        }
        if (format && format.toString()) {
            _format = format.toString();
        }
        if (_format.toString().toUpperCase() === 'MPEG4') {
            return 'mp4';
        }
        if (/^xlsx-model/i.test(_format)) {
            return 'xlsx';
        }
        return _format.toLowerCase();
    };
    /**
     * @deprecated
     * **Please stop using this!**
     * It should work, but it's using Library service. Shouldn't you use BSS instead?
     * Try BlobStorageApiService
     */
    CommonHelperService.prototype.getIconUrl = function (imageName, tintColor, resize) {
        var loginInfo = this.userService.getLoginInfo();
        if (imageName) {
            var url = SeismicUrlConstants_1.SeismicUrlConstants.FILE_SERVICE_URL +
                '/Image.ashx?tenant=' +
                loginInfo.tenant +
                '&user=' +
                this.escapeUserName(loginInfo.username) +
                '&client=' +
                loginInfo.clientType +
                '&imageid=' +
                imageName +
                '&tintcolor=' +
                tintColor +
                '&isembeddedresource=true';
            if (resize) {
                url += '&resize=' + resize;
            }
            return url;
        }
        return '';
    };
    CommonHelperService.prototype.escapeUserName = function (username) {
        if (!username) {
            return '';
        }
        return encodeURIComponent(username).replace(/'/gi, '%27');
    };
    /**
     * @deprecated
     * **Please stop using this!**
     * Please use **UserService.getUserNameInitials()** or **UserService.getCurrentUserNameInitials()** as an alternative.
     */
    CommonHelperService.prototype.getUserNameInitials = function () {
        var fullName = this.userService.getLoginInfo().fullname;
        var userName = this.userService.getLoginInfo().username;
        var fullNameSplit = fullName === null || fullName === void 0 ? void 0 : fullName.split(' ');
        var firstName = fullNameSplit && fullNameSplit[0];
        var lastName = fullNameSplit && fullNameSplit.length > 1 && fullNameSplit[1];
        var nameInitials = '';
        if (firstName && lastName) {
            nameInitials = firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
        }
        else {
            nameInitials = userName.charAt(0).toUpperCase();
        }
        return nameInitials;
    };
    var CommonHelperService_1;
    CommonHelperService.EXTERNALRESOURCESCDN = 'https://smc-prod-cdn.seismic.com/static/external-resources/';
    CommonHelperService.IMAGE_NOT_FOUND_URL = CommonHelperService_1.EXTERNALRESOURCESCDN + "images/ImageNotFound.png";
    CommonHelperService = CommonHelperService_1 = __decorate([
        CommonService_decorator_1.CommonService('CommonHelperService', { replaceAngularService: ['commonHelper', '__DONT_USE_CommonHelper'] }),
        __metadata("design:paramtypes", [MonolithUser_service_1.MonolithUserService,
            JsonApi_service_1.JsonApiService,
            ServiceAddress_service_1.ServiceAddressService,
            PreloadData_service_1.PreloadDataService])
    ], CommonHelperService);
    return CommonHelperService;
}());
exports.CommonHelperService = CommonHelperService;
var OLD_PREVIEW_NAME = 'file.png';
var OLD_URL_PREVIEW_NAME = 'turl.png-C';
var NEW_URL_THUMBNAIL_URL = '/X5/src/apps/new-doccenter/common/theme/images/grid-thumbnail-url.jpg';
var NEW_THUMBNAIL_URL = '/X5/src/apps/new-doccenter/common/theme/images/new-content-thumbnail.png';
//# sourceMappingURL=CommonHelper.service.js.map